import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useWaitlistCount = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let live = true;
    const fetchCount = () => {
      axios
        .get(`${API}/waitlist/count`)
        .then((r) => { if (live) setCount(r.data.displayCount ?? r.data.completed ?? r.data.count ?? 0); })
        .catch(() => { if (live) setCount(0); });
    };
    fetchCount();
    // Refresh when a new submission completes anywhere on the page
    const onJoined = () => fetchCount();
    window.addEventListener("gf:waitlist-joined", onJoined);
    // Light auto-refresh every 60s so the homepage feels live
    const id = setInterval(fetchCount, 60000);
    return () => {
      live = false;
      window.removeEventListener("gf:waitlist-joined", onJoined);
      clearInterval(id);
    };
  }, []);

  return count; // null while loading, then the real number
};

/** Smart label that adapts to launch-day reality */
export const socialProofLabel = (count) => {
  if (count === null) return "Loading…";
  if (count === 0)   return "Be the first to join";
  if (count === 1)   return "1 earner on the list";
  if (count < 25)    return `${count} earners · early access`;
  if (count < 100)   return `${count} earners signed up`;
  return `${count.toLocaleString()} earners waiting`;
};
